// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "web-app/js/" + chunkId + "." + {"267":"c304f6b59531aa253493","543":"9bf8b06f950b8b6052b3","621":"c76ac617321df98f31c1","625":"c1cbb661380c496321fe"}[chunkId] + ".chunk.js";
};